import React, { createContext, useContext, useState } from 'react';
import fi from './fi';
import en from './en';

const translations = { fi, en };
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('onetrack_language') || 'fi';
  });

  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }

    if (typeof value !== 'string') {
      return key; // Return key if translation not found
    }

    // Replace {param} placeholders with actual values
    return value.replace(/\{(\w+)\}/g, (_, param) => params[param] ?? `{${param}}`);
  };

  const changeLanguage = (lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('onetrack_language', lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, availableLanguages: ['fi', 'en'] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    // Fallback for components outside provider
    return {
      language: 'fi',
      t: (key) => key,
      changeLanguage: () => {},
      availableLanguages: ['fi', 'en']
    };
  }
  return context;
};

export default LanguageContext;
